import Resource from '../Resource'

export default class WritingTestAnswer extends Resource {
  static ENDPOINT = '/api/test/writing/answer'

  constructor (args) {
    super()
    if (args) {
      Object.keys(args).forEach(arg => {
        this[arg] = args[arg]
      })
    }
  }

  static create (training, student, test, name, code, seq) {
    const testAnswers = []
    test.test.forEach(t => {
      const a = {
        name: t.unitName,
        code: t.uniCode
      }
      a.answers = t.questions.map(q => ({ answer: 0 })) // 테스트
      testAnswers.push(a)
    })

    return new WritingTestAnswer({ training, student, test: test._id, name, code, seq, testAnswers })
  }

  mark (test, teacher) {
    let score = 0
    test.forEach((t, tx) => {
      t.questions.forEach((q, qx) => {
        if (q.answer === this.testAnswers[tx].answers[qx].answer) {
          score += q.assignScore
        }
      })
    })
    this.teacher = teacher
    this.score = Math.round(score)
  }
}
